import { Autocomplete, TextField } from "@mui/material";
import useGlobalContext from "hooks/globalData";
import { useQuery } from "react-query";
import {
  FilterLicense,
  UserLicenseFilter,
} from "services/organizationPortalClient";
import contextStore from "stores/contextStore";
import { useIntl } from "react-intl";

type SelectLicenseProps = {
  value: UserLicenseFilter[];
  onChange: (v: FilterLicense[]) => void;
};

const SelectLicense = ({ onChange, value }: SelectLicenseProps) => {
  const { formatMessage: t } = useIntl();
  const { enrollmentService } = useGlobalContext();
  const { organization } = contextStore.useState();

  const { data, isFetching } = useQuery(
    ["enrollmentService.getLicenses", organization?.id],
    () => enrollmentService.getLicenses()
  );

  const handleChangeMultiple = (_: any, values: FilterLicense[]) => {
    onChange(values);
  };

  const options = data?.data ?? [];

  return (
    <Autocomplete
      multiple
      options={options}
      getOptionLabel={(option) =>
        option.licensureBodyAcronym ||
        option.licensureBodyName ||
        option.stateName ||
        "?"
      }
      value={options.filter(
        (r) =>
          value.some(
            (v) =>
              (r.licensureBodyId && r.licensureBodyId === v.licensureBodyId) ||
              (r.stateId && r.stateId === v.stateId)
          ) ?? false
      )}
      onChange={handleChangeMultiple}
      loading={isFetching}
      size="small"
      groupBy={(option) => (option.licensureBodyId ? t({ id: "national" }) : t({ id: "state" }))}
      renderInput={(params) => (
        <TextField {...params} label={t({ id: "licenses" })} size="small" />
      )}
    />
  );
};

export default SelectLicense;
